export default {
    dataRequestDonationLocation: state => state.dataRequestDonationLocation,
    dataDonationLocation: state => state.dataDonationLocation,
    dataDonationLocationResponseData: state => state.dataDonationLocation.responseData,
    dataCreateBookingTab: state => state.dataCreateBookingTab,
    dataBookingAppointment: state => state.dataBookingAppointment,
    showPage: state => state.showPage,
    showPageTriggerDonationLocation: state => state.showPage.triggerDonationLocation,
    showPageTriggerBookingAppointment: state => state.showPage.triggerBookingAppointment,
    actionVariableDonateBlood: state => state.actionVariableDonateBlood,
    entryPoint: state => state.entryPoint,
}